/**
 * PHP API origin. Override with VUE_APP_API_BASE in a .env file (no trailing slash).
 */
const DEFAULT_API_BASE = 'https://colorize.speedyimg.com';

export function getApiBaseUrl() {
  const raw = process.env.VUE_APP_API_BASE || DEFAULT_API_BASE;
  return String(raw).replace(/\/$/, '');
}
